import { isKeyOf } from "@/helpers/typeHelpers";
import type { MaybeRefOrGetter } from "vue";
import { computed, toRef, toValue } from "vue";

const statusIconMap: Record<string, [string, string]> = {
	"01 Aan te leveren": ["radio_button_checked", "text-gray-400"],
	"02 In behandeling": ["pending", "text-gray-400"],
	"03 Ontvangen": ["visibility", "text-gray-400"],
	"04 Akkoord": ["check_circle", "text-green-500"],
	"06 Voorlopig akkoord": ["preliminary", "text-green-500"],
	"07 Afgekeurd en opnieuw aan te leveren (zie toelichting)": [
		"cancel",
		"text-red-500",
	],
	"08 Vervallen (zie toelichting)": ["hourglass_disabled", "text-gray-400"],
};
const helpIcon = { name: "help", color: "text-gray-400" };

export function useLoanApplicationDocumentIcon(
	documentStatus: MaybeRefOrGetter<string | undefined>,
) {
	const icon = computed(() => {
		const status = toValue(documentStatus);
		if (!status) {
			return helpIcon;
		}
		const [name, color] = isKeyOf(statusIconMap, status)
			? (statusIconMap[status] ?? [helpIcon.name, helpIcon.color])
			: [helpIcon.name, helpIcon.color];

		return { name, color };
	});

	const name = toRef(() => icon.value.name);
	const color = toRef(() => icon.value.color);

	return { iconName: name, iconColor: color };
}
